module.exports = __webpack_public_path__ + "img/product2.6c3c115b.png";